import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import { TagsInput } from "react-tag-input-component";
import { DeletePreBookingRoom, getBasicPropertydetails, GetPreBookingRoomdetail, PropeortyBookingConfirm, PropertyBusinessSourceList, PropertyGuaranteeCodes, PropertyMarketSegmentApi, PropertyMealplan, PropertyRateCode, roomlistdetail, SavePreBookingRoomAdd } from '../../Services/Service';

const HotelBooking = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [masterDetails, setMasterDetails] = useState({});
  const [roomDetails, setRoomDetails] = useState([]);
  const [tax, setTax] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [, setTotalAfterTax] = useState(0);
  const [, setTaxAmount] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [mealPlans, setMealPlans] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [selectedRatePlan, setSelectedRatePlan] = useState(null);
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [extraBed, setExtraBed] = useState(0);
  const [marketSegments, setMarketSegments] = useState([]);
  const [businessSources, setBusinessSources] = useState([]);
  const [editingRoomId, setEditingRoomId] = useState(null); // track which row is being edited
  const [tempAmount, setTempAmount] = useState({});
  const [roomAmount, setRoomAmount] = useState(0);
  const [Pms, setPMS] = useState();
  const [guaranteeCodes, setGuaranteeCodes] = useState([]);
  const [ratecode, setRatecode] = useState([]);
  const [mealplan, setMealplan] = useState([]);

  const [selectedRateCode, setSelectedRateCode] = useState("");

  const [editingRowKey, setEditingRowKey] = useState(null); // unique per rendered row

  const [savedAmounts, setSavedAmounts] = useState({});

  const [rowTax, setRowTax] = useState({});
  const [rowTaxAmount, setRowTaxAmount] = useState({});
  const [rowTotal, setRowTotal] = useState({});
  const [savedRowTaxAmount, setSavedRowTaxAmount] = useState({});



  // useEffect(() => {
  //   const fetchBookingData = async () => {
  //     try {
  //       const result = await GetPreBookingRoomdetail();
  //       console.log("Fetched booking data:", result);

  //       if (result?.MasterDetails?.length) {
  //         setMasterDetails(result.MasterDetails[0]);
  //       }

  //       if (result?.RoomDetails?.length) {
  //         setRoomDetails(result.RoomDetails);

  //         // const amount = result.RoomDetails.reduce(
  //         //   (acc, room) => acc + ((room.PerRoomRate || room.RoomRate || 0) + ((room.ExtraBed || 0) * (room.ExtraBedCharges || 0))),
  //         //   0
  //         // );

  //         const amount = result.RoomDetails.reduce((acc, room) => {
  //           const roomRate = room.RoomRate || room.PerRoomRate || 0;
  //           const totalRoomCount = room.TotalRoom || 1;

  //           // If API already gives ExtraBedAmount, use it
  //           const extraBedTotal =
  //             room.ExtraBedAmount !== undefined
  //               ? room.ExtraBedAmount
  //               : (room.ExtraBed || 0) * (room.ExtraBedCharges || 0);

  //           return acc + totalRoomCount * roomRate + extraBedTotal;
  //         }, 0);

  //         console.log("ammount", amount);
  //         setTotalAmount(amount);

  //         // const taxPercent = result.TaxDetails?.[0]?.Tax || 0;
  //         // setTax(taxPercent);

  //         const taxPercent = amount < 7500 ? 5 : 18;
  //         setTax(taxPercent);

  //         const calculatedTaxAmount = (amount * taxPercent) / 100;
  //         setTaxAmount(calculatedTaxAmount);

  //         const afterTax = amount + calculatedTaxAmount;
  //         setTotalAfterTax(afterTax);
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch booking data", err);
  //     }
  //   };

  //   fetchBookingData();
  // }, []);

  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const result = await GetPreBookingRoomdetail();
        console.log("Fetched booking data:", result);

        if (result?.MasterDetails?.length) {
          const master = result.MasterDetails[0];
          setMasterDetails(master);

          // Try to parse CompDetails (it may be a JSON string like "[{...}]")
          try {
            const compRaw = master.CompDetails;
            if (compRaw) {
              let compParsed = compRaw;

              // If it's a string, try to JSON.parse
              if (typeof compRaw === "string") {
                // sometimes it's double-encoded or a JSON array string
                compParsed = JSON.parse(compRaw);
              }

              // compParsed expected to be an array or object; normalize to first object
              const compObj = Array.isArray(compParsed) ? compParsed[0] : compParsed;

              if (compObj && typeof compObj === "object") {
                // Map API fields -> our form fields
                const registrationNumber = compObj.Gst ?? "";
                const registrationCompanyName = compObj.TA_Name ?? "";
                const registrationCompanyAddress = compObj.Address ?? "";

                // Update formData with parsed values
                setFormData((prev) => ({
                  ...prev,
                  RegistrationNumber: registrationNumber,
                  RegistrationCompanyName: registrationCompanyName,
                  RegistrationCompanyAddress: registrationCompanyAddress,
                }));
              }
            }
          } catch (parseErr) {
            console.warn("Failed to parse CompDetails:", parseErr);
          }
        }

        if (result?.RoomDetails?.length) {
          setRoomDetails(result.RoomDetails);

          const amount = result.RoomDetails.reduce((acc, room) => {
            const roomRate = room.RoomRate || room.PerRoomRate || 0;
            const totalRoomCount = room.TotalRoom || 1;

            // If API already gives ExtraBedAmount, use it
            const extraBedTotal =
              room.ExtraBedAmount !== undefined
                ? room.ExtraBedAmount
                : (room.ExtraBed || 0) * (room.ExtraBedCharges || 0);

            return acc + totalRoomCount * roomRate + extraBedTotal;
          }, 0);

          console.log("ammount", amount);
          setTotalAmount(amount);

          // use TaxDetails from API if present, otherwise fallback to amount-based logic
          let taxPercent = 0;
          if (result?.TaxDetails && result.TaxDetails.length && result.TaxDetails[0].Tax != null) {
            taxPercent = Number(result.TaxDetails[0].Tax) || 0;
          } else {
            taxPercent = amount < 7500 ? 5 : 18;
          }
          setTax(taxPercent);

          const calculatedTaxAmount = (amount * taxPercent) / 100;
          setTaxAmount(calculatedTaxAmount);

          const afterTax = amount + calculatedTaxAmount;
          setTotalAfterTax(afterTax);
        }
      } catch (err) {
        console.error("Failed to fetch booking data", err);
      }
    };

    fetchBookingData();
  }, []);


  const calculateNights = (checkInIso, checkOutIso) => {
    // checkInIso / checkOutIso 
    if (!checkInIso || !checkOutIso) return 0;

    // agar API se full ISO milta hai, pehle date part lo (yyyy-mm-dd)
    const inDateStr = checkInIso.split("T")[0];
    const outDateStr = checkOutIso.split("T")[0];

    // create Date objects at midnight to avoid timezone shifts
    const inDate = new Date(inDateStr + "T00:00:00");
    const outDate = new Date(outDateStr + "T00:00:00");

    const diffMs = outDate.getTime() - inDate.getTime();
    if (isNaN(diffMs) || diffMs <= 0) return 0;

    const days = Math.round(diffMs / (24 * 60 * 60 * 1000));
    return days;
  };


  // const nights = calculateNights(masterDetails?.CheckInDate, masterDetails?.CheckOutDate) || 0;

  // // base = amount × nights
  // const baseAmount = Number(totalAmount || 0) * nights;

  // // tax amount = baseAmount ka selected %
  // const finalTaxAmount = (baseAmount * Number(tax || 0)) / 100;

  // // total after tax
  // const finalTotalAfterTax = baseAmount + finalTaxAmount;



  const [formData, setFormData] = useState({
    Title: "Mr.",
    FirstName: "",
    MiddleName: "",
    LastName: "",
    EmailAddress: [],
    Address: "",
    MobileNumber: "",
    Country: "",
    State: "",
    City: "",
    CompanyName: "",
    RegistrationNumber: "",
    RegistrationCompanyName: "",
    RegistrationCompanyAddress: "",

    BillingInstruction: "",
    MarketSegment: "",
    BusinessSource: "",
    GuaranteeCodes: "",
    BookingComment: "",
    PaymentComment: "",
  });



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { Title, FirstName, LastName, MobileNumber } = formData;

    if (!Title || !FirstName || !LastName || !MobileNumber) {
      swal("Please fill all guest details ", {
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-warning",
          },
        },
      });
      setLoading(false);
      return;
    }


    const payload = {
      PreBookingToken: masterDetails?.PreBookingToken,
      TotalRoomRate: baseAmount,
      TotalExtraBedCharges: 0,
      TotalPayment: baseAmount,
      Tax: tax,
      TotalAfterTax: finalTotalAfterTax,
      Discount: 0,
      ...formData,
    };

    console.log("booking data", payload);

    try {
      await PropeortyBookingConfirm(payload);

      swal("Your booking details submitted to Hotel!", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      }).then(() => {
        navigate("/Property/Bookinglist", { state: { showSuccess: true } });
      });

    } catch (error) {
      swal("Booking Failed.", {
        icon: "error",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-danger",
          },
        },
      });
    } finally {
      setLoading(false);
    }
  };


  const handleDeleteRoom = (roomId) => {
    if (!roomId) {
      alert("Missing Room ID.");
      return;
    }

    swal({
      title: "Are you sure?",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
          className: "btn btn-danger",
          closeModal: true,
        },
        confirm: {
          text: "Yes, delete it!",
          className: "btn btn-success",
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      setLoading(true);

      try {
        // Optionally call API to delete room on backend
        const result = await DeletePreBookingRoom(roomId, masterDetails?.PreBookingToken);

        if (result?.PreBookingToken) {
          // Remove room from local state only
          const updatedRooms = roomDetails.filter(r => r.ID !== roomId);
          setRoomDetails(updatedRooms);

          // Recalculate total amount
          const amount = updatedRooms.reduce(
            (acc, r) => acc + (r.Amount !== undefined ? r.Amount : (r.TotalRoom * r.RoomRate + (r.ExtraBedAmount || 0))),
            0
          );
          setTotalAmount(amount);

          // Recalculate tax
          const taxPercent = tax; // keep existing tax percent
          const taxAmt = (amount * taxPercent) / 100;
          setTaxAmount(taxAmt);
          setTotalAfterTax(amount + taxAmt);

          // Optional: alert user
          // alert("Room deleted successfully");
        } else {
          alert("Failed to delete room.");
        }
      } catch (error) {
        console.error("Error deleting room:", error);
        alert("Something went wrong while deleting the room.");
      } finally {
        setLoading(false);
      }
    });
  };



  // add room api 
  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const result = await roomlistdetail();
        if (result && Array.isArray(result)) {
          setRooms(result);
        }
      } catch (err) {
        console.error("Error fetching rooms:", err);
      }
    };
    fetchRooms();
  }, []);

  // jab room change hoga → uske meal plans nikalenge
  // const handleRoomChange = (e) => {
  //   const roomId = e.target.value;
  //   const room = rooms.find((r) => r.RoomID.toString() === roomId);
  //   setSelectedRoom(room);

  //   if (room?.RatePlanDetails) {
  //     try {
  //       const parsedPlans = JSON.parse(room.RatePlanDetails);
  //       console.log("Parsed meal plans:", parsedPlans);
  //       setMealPlans(parsedPlans);
  //     } catch (err) {
  //       console.error("Error parsing RatePlanDetails:", err);
  //       setMealPlans([]);
  //     }
  //   } else {
  //     setMealPlans([]);
  //   }
  // };

  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = rooms.find((r) => r.RoomID.toString() === roomId);
    setSelectedRoom(room);

    // reset rate/meal selections
    setSelectedMealPlan(null);
    setSelectedRatePlan(null);

    if (room?.RatePlanDetails) {
      try {
        // parse JSON string
        const parsedPlans = JSON.parse(room.RatePlanDetails);
        // Optionally normalize the keys (some entries use 'MeelPlan' spelling)
        const normalized = parsedPlans.map(p => ({
          RatePlanID: p.RatePlanID,
          RatePlan: p.RatePlan,
          MealPlan: p.MeelPlan ?? p.MealPlan ?? ""   // prefer MeelPlan if present
        }));
        setMealPlans(normalized);
      } catch (err) {
        console.error("Error parsing RatePlanDetails:", err);
        setMealPlans([]);
      }
    } else {
      setMealPlans([]);
    }
  };


  const resetForm = () => {
    setSelectedRoom(null);
    setMealPlans([]);
    setSelectedMealPlan(null);
    setRoomAmount(0);
    setAdults("0");
    setChildren("0");
    setExtraBed("0");
  };

  useEffect(() => {
    if (!roomDetails || !roomDetails.length) return;

    const newTotal = roomDetails.reduce((acc, r) => {
      const roomRate = Number(r.RoomRate || r.Amount || 0);
      const extraBed = Number(r.ExtraBedAmount || 0);
      const totalRoomCount = Number(r.TotalRoom || 1);
      return acc + totalRoomCount * roomRate + extraBed;
    }, 0);

    setTotalAmount(newTotal);

    const taxPercent = newTotal < 7500 ? 5 : 18;
    setTax(taxPercent);

    const calculatedTaxAmount = (newTotal * taxPercent) / 100;
    setTaxAmount(calculatedTaxAmount);

    setTotalAfterTax(newTotal + calculatedTaxAmount);
  }, [roomDetails]);




  // const handleAddRoomSave = async () => {
  //   if (!selectedRoom) {
  //     swal("Please select a room type!", {
  //       icon: "warning",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-warning",
  //         },
  //       },
  //     });
  //     return;
  //   }

  //   const preBookingToken = localStorage.getItem("PreBookingToken");

  //   const baseRoomRate = Number(roomAmount) || 0;
  //   const extraBedAmount = 1500 * Number(extraBed);

  //   const formData = new FormData();
  //   formData.append("ID", "0");
  //   formData.append("PreBookingToken", preBookingToken);
  //   formData.append("RoomID", selectedRoom.RoomID);
  //   formData.append("RatePlanID", selectedMealPlan?.RatePlanID || 0);
  //   formData.append("TotalRoom", "1");
  //   formData.append("RoomRate", baseRoomRate);
  //   formData.append("ExtraBed", extraBed);
  //   formData.append("ExtraBedAmount", extraBedAmount);
  //   formData.append("Adults", adults);
  //   formData.append("Child", children);
  //   formData.append("MealPlanID",);

  //   try {
  //     setLoading(true);
  //     const result = await SavePreBookingRoomAdd(formData);
  //     console.log("Room added successfully", result);

  //     swal("Room added successfully!", {
  //       icon: "success",
  //       buttons: {
  //         confirm: {
  //           text: "OK",
  //           className: "btn btn-success",
  //         },
  //       },
  //     }).then(async () => {
  //       const modalElement = document.getElementById("con-close-modal");
  //       if (modalElement) {
  //         const modal = window.bootstrap.Modal.getInstance(modalElement);
  //         if (modal) modal.hide();
  //       }

  //       resetForm();

  //       const updatedBooking = await GetPreBookingRoomdetail();
  //       if (Array.isArray(updatedBooking?.RoomDetails)) {
  //         setRoomDetails(updatedBooking.RoomDetails);
  //       }
  //     });

  //   } catch (error) {
  //     console.error("Error adding room", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // get market segment

  // edit button click

  const handleAddRoomSave = async () => {
    if (!selectedRoom) {
      swal("Please select a room type!", {
        icon: "warning",
        buttons: {
          confirm: { text: "OK", className: "btn btn-warning" },
        },
      });
      return;
    }

    const preBookingToken = localStorage.getItem("PreBookingToken");

    const totalRooms = Number(1);
    const baseRoomRate = Number(roomAmount) || 0;
    const extraBedCount = Number(extraBed) || 0;
    const EXTRA_BED_PRICE = 1500;
    const extraBedAmount = EXTRA_BED_PRICE * extraBedCount * totalRooms;

    const adultsCount = Number(adults) || 0;
    const childrenCount = Number(children) || 0;

    const formData = new FormData();
    formData.append("ID", "0");
    formData.append("PreBookingToken", preBookingToken);
    formData.append("RoomID", selectedRoom.RoomID);
    formData.append("RatePlanID", selectedRateCode || "");
    formData.append("TotalRoom", totalRooms.toString());
    formData.append("RoomRate", baseRoomRate.toString());
    formData.append("ExtraBed", extraBedCount.toString());
    formData.append("ExtraBedAmount", extraBedAmount.toString());
    formData.append("Adults", adultsCount.toString());
    formData.append("Child", childrenCount.toString());
    formData.append("MealPlanID", selectedMealPlan || "");

    try {
      setLoading(true);
      const result = await SavePreBookingRoomAdd(formData);
      console.log("Room added successfully", result);

      swal("Room added successfully!", {
        icon: "success",
        buttons: {
          confirm: { text: "OK", className: "btn btn-success" },
        },
      }).then(async () => {
        const modalElement = document.getElementById("con-close-modal");
        if (modalElement) {
          const modal = window.bootstrap.Modal.getInstance(modalElement);
          if (modal) modal.hide();
        }
        resetForm();
        const updatedBooking = await GetPreBookingRoomdetail();
        if (Array.isArray(updatedBooking?.RoomDetails)) {
          setRoomDetails(updatedBooking.RoomDetails);
        }
      });
    } catch (error) {
      console.error("Error adding room", error);
    } finally {
      setLoading(false);
    }
  };


  // const handleEditClick = (roomID, currentAmount) => {
  //   setEditingRoomId(roomID);
  //   setTempAmount(prev => ({ ...prev, [roomID]: currentAmount }));
  // };

  // // input change (sirf local state me rakhega)
  // const handleAmountInputChange = (roomID, value) => {
  //   const numericValue = value === "" ? "" : parseFloat(value);
  //   setTempAmount(prev => ({ ...prev, [roomID]: numericValue }));
  // };

  // const handleCancelClick = () => {
  //   setEditingRoomId(null);
  // };

  const handleEditClick = (rowKey, initialAmount) => {
    setEditingRowKey(rowKey);
    setTempAmount(prev => ({ ...prev, [rowKey]: initialAmount }));
  };

  // input change (local only)
  const handleAmountInputChange = (rowKey, value) => {
    // allow empty string while editing to let user clear input
    const numericValue = value === "" ? "" : parseFloat(value);
    setTempAmount(prev => ({ ...prev, [rowKey]: numericValue }));
  };

  const handleCancelClick = () => {
    setEditingRowKey(null);
  };


  // const handleSaveClick = async (rowKey, room, instanceIndex) => {
  //   // value typed
  //   const typedVal = tempAmount[rowKey];
  //   const numericValue = typedVal === "" || typedVal === undefined ? 0 : Number(typedVal);

  //   // 1) create a new savedAmounts map including this new value (use locally for recalculation)
  //   const newSaved = { ...savedAmounts, [rowKey]: numericValue };
  //   setSavedAmounts(newSaved);

  //   // 2) recalc totals using roomDetails + newSaved (including this new value)
  //   const newTotal = roomDetails.flatMap((r, rIdx) =>
  //     Array.from({ length: r.TotalRoom || 1 }, (_, idx) => {
  //       const key = `${rIdx}-${idx}`;
  //       // prefer newSaved for that instance, otherwise fallback to r.Amount or computed default
  //       const fallback = r.Amount ?? (r.TotalRoom * r.RoomRate + (r.ExtraBedAmount || 0));
  //       const amt = newSaved[key] ?? fallback;
  //       return Number(amt || 0);
  //     })
  //   ).reduce((acc, v) => acc + v, 0);

  //   setTotalAmount(newTotal);
  //   const taxPercent = newTotal < 7500 ? 5 : 18;
  //   setTax(taxPercent);
  //   const calculatedTaxAmount = (newTotal * taxPercent) / 100;
  //   setTaxAmount(calculatedTaxAmount);
  //   setTotalAfterTax(newTotal + calculatedTaxAmount);

  //   const selectedTax = Number(rowTax[rowKey] ?? 0);
  //   const selectedTaxAmount = Number(rowTaxAmount[rowKey] ?? 0);
  //   const selectedTotalAmount = Number(rowTotal[rowKey] ?? numericValue);

  //   // 3) Prepare formData for API (same as your original)
  //   const preBookingToken = localStorage.getItem("PreBookingToken") || "";
  //   const formData = new FormData();
  //   formData.append("ID", room.ID || "N/A");
  //   formData.append("PreBookingToken", preBookingToken);
  //   formData.append("RoomID", room.RoomID);
  //   formData.append("RatePlanID", room.RatePlanID || "");
  //   formData.append("TotalRoom", room.TotalRoom || 1);
  //   formData.append("RoomRate", numericValue);
  //   formData.append("ExtraBed", room.ExtraBed || 0);
  //   formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
  //   formData.append("Adults", room.Adults || 0);
  //   formData.append("Child", room.Child || 0);
  //   formData.append("MealPlanID", room.MealPlanID || "Null");
  //   formData.append("Tax", selectedTax);
  //   formData.append("TaxRate", selectedTaxAmount);
  //   formData.append("NetAmount", selectedTotalAmount);

  //   // console.log("=== FORMDATA PAYLOAD ===");
  //   // for (let pair of formData.entries()) {
  //   //   console.log(pair[0], ":", pair[1]);
  //   // }

  //   try {
  //     const result = await SavePreBookingRoomAdd(formData);
  //     if (result?.RoomDetails) {
  //       setRoomDetails(result.RoomDetails);
  //       setSavedAmounts({});
  //     }
  //     swal("Amount updated successfully!", {
  //       icon: "success",
  //       buttons: { confirm: { text: "OK", className: "btn btn-success" } },
  //     });
  //     setShowTaxSummary(true);
  //   } catch (error) {
  //     console.error("Error saving room data:", error);
  //   }

  //   // 4) close edit mode
  //   setEditingRowKey(null);
  // };

  const handleSaveClick = async (rowKey, room, instanceIndex) => {
    // 🔹 Amount typed in input
    const typedVal = tempAmount[rowKey];
    const numericValue =
      typedVal === "" || typedVal === undefined ? 0 : Number(typedVal);

    // 🔹 1. SAVE AMOUNT (COMMIT)
    setSavedAmounts(prev => ({
      ...prev,
      [rowKey]: numericValue,
    }));

    // 🔹 2. SAVE TAX ONLY FOR THIS ROW (COMMIT)
    const selectedTaxAmount = Number(rowTaxAmount[rowKey] ?? 0);

    setSavedRowTaxAmount(prev => ({
      ...prev,
      [rowKey]: selectedTaxAmount,
    }));

    // 🔹 3. Prepare API payload
    const preBookingToken = localStorage.getItem("PreBookingToken") || "";
    const formData = new FormData();

    formData.append("ID", room.ID || "N/A");
    formData.append("PreBookingToken", preBookingToken);
    formData.append("RoomID", room.RoomID);
    formData.append("RatePlanID", room.RatePlanID || "");
    formData.append("TotalRoom", room.TotalRoom || 1);
    formData.append("RoomRate", numericValue);
    formData.append("ExtraBed", room.ExtraBed || 0);
    formData.append("ExtraBedAmount", room.ExtraBedAmount || 0);
    formData.append("Adults", room.Adults || 0);
    formData.append("Child", room.Child || 0);
    formData.append("MealPlanID", room.MealPlanID || "Null");
    formData.append("Tax", Number(rowTax[rowKey] ?? 0));
    formData.append("TaxRate", selectedTaxAmount);
    formData.append("NetAmount", numericValue + selectedTaxAmount);

    try {
      const result = await SavePreBookingRoomAdd(formData);

      if (result?.RoomDetails) {
        setRoomDetails(result.RoomDetails);
      }

      swal("Amount updated successfully!", {
        icon: "success",
        buttons: { confirm: { text: "OK", className: "btn btn-success" } },
      });



    } catch (error) {
      console.error("Error saving room data:", error);
    }

    // 🔹 4. Exit edit mode
    setEditingRowKey(null);
  };






  useEffect(() => {
    const fetchSegments = async () => {
      try {
        setLoading(true);
        const data = await PropertyMarketSegmentApi();
        if (data) {
          setMarketSegments(data);
        }
      } catch (err) {
        console.error("Error fetching market segments", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSegments();
  }, []);


  // get Business Source
  useEffect(() => {
    const fetchBusinessSources = async () => {
      try {
        const data = await PropertyBusinessSourceList();
        if (data && Array.isArray(data)) {
          setBusinessSources(data);
        }
      } catch (error) {
        console.error("Error fetching business sources", error);
      }
    };
    fetchBusinessSources();
  }, []);


  useEffect(() => {
    const FetchPMS = async () => {
      try {
        const result = await getBasicPropertydetails();
        if (result && result.length > 0) {
          setPMS(result[0]);
        }
      }
      catch (error) {
        console.log("error fetch Pms in get api", error);
      }
    }
    FetchPMS();
  }, [])


  useEffect(() => {
    const fetchGuaranteeCodes = async () => {
      setLoading(true);
      try {
        const data = await PropertyGuaranteeCodes();
        if (Array.isArray(data)) setGuaranteeCodes(data);
      } catch (error) {
        console.log("Error fetching gurantee Codes:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuaranteeCodes();
  }, []);


  useEffect(() => {
    const fetchRatecode = async () => {
      setLoading(true);
      try {
        const result = await PropertyRateCode();
        if (Array.isArray(result)) setRatecode(result);
      } catch (error) {
        console.log("error get rate code", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRatecode();
  }, []);

  useEffect(() => {
    const FetchMealplan = async () => {
      setLoading(true);
      try {
        const result = await PropertyMealplan();
        if (Array.isArray(result)) setMealplan(result);

      } catch (error) {
        console.log("error get meal plan", error);
      } finally {
        setLoading(false);
      }
    };
    FetchMealplan();
  }, []);

  const calculateRowAmounts = (rowKey, amount, taxPercent) => {
    const taxAmt = (Number(amount) * Number(taxPercent || 0)) / 100;
    const total = Number(amount) + taxAmt;

    setRowTaxAmount(prev => ({
      ...prev,
      [rowKey]: taxAmt,
    }));

    setRowTotal(prev => ({
      ...prev,
      [rowKey]: total,
    }));
  };



  const nights = calculateNights(
    masterDetails?.CheckInDate,
    masterDetails?.CheckOutDate
  ) || 0;


  // ✅ BASE AMOUNT = sab rows ke amount ka sum
  const baseAmount = roomDetails
    .flatMap((room, roomIdx) =>
      Array.from({ length: room.TotalRoom || 1 }, (_, index) => {
        const rowKey = `${roomIdx}-${index}`;

        // per night amount
        const perNightAmount =
          room.Amount ??
          (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

        return Number(savedAmounts[rowKey] ?? perNightAmount ?? 0);
      })
    )
    .reduce((sum, val) => sum + Number(val), 0) * nights;



  // ✅ FINAL TAX AMOUNT = sab rows ke tax ka sum
  // const finalTaxAmount = Object.values(rowTaxAmount).reduce(
  //   (sum, val) => sum + Number(val || 0),
  //   0
  // );

  const finalTaxAmount =
    Object.values(savedRowTaxAmount).reduce(
      (sum, val) => sum + Number(val || 0),
      0
    ) * nights;

  const finalTotalAfterTax = baseAmount + finalTaxAmount;



  return (
    <>
      <style> {`
        th {
          background-color:#a2a7b7 !important;
          color: #fff !important;
        }
          .table td {
    border-bottom: 0px;
      }
      `}
      </style>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card mb-0 ">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Property Room Details</h4>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">Arrival:</label>
                              <input type="date" className="form-control" value={masterDetails?.CheckInDate?.split("T")[0] || ""} readOnly />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Departure:
                              </label>
                              <input type="date" className="form-control" value={masterDetails?.CheckOutDate?.split("T")[0] || ""} readOnly />
                            </div>
                          </div>

                          <div className="col-md-1 mb-3">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Nights
                              </label>
                              <input type='text' className='form-control'
                                value={calculateNights(masterDetails?.CheckInDate, masterDetails?.CheckOutDate) || 0}
                                readOnly />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="input-block ">
                              <label className="col-form-label">
                                Rate Code:
                              </label>
                              <select className="form-control form-select" value={masterDetails?.RateCode || ''} disabled>
                                <option value="">{masterDetails?.RateCode || "Select Type"}</option>
                              </select>
                            </div>
                          </div>





                          {/*hotel rooom table */}

                          <div className="col-md-12">
                            <div className="table-responsive">
                              <div className='text-end'>
                                {/* <button type="button" className="btn btn-sm btn-primary mb-2 " data-bs-toggle="modal" data-bs-target="#con-close-modal"> <i className='fas fa-plus'></i> ADD </button> */}
                              </div>
                              <table
                                className="display table  table-bordered "

                              >
                                <thead>
                                  <tr >
                                    <th className='th'> Room Type </th>

                                    {Pms?.PMS === "Opera" && (<th>Rate Plan</th>)}
                                    <th> Meal Plan </th>
                                    {/* <th>  Rooms </th> */}
                                    <th style={{ width: "50px" }}> Adult's</th>
                                    <th style={{ width: "50px" }}>Child's</th>
                                    <th style={{ width: "60px" }}> Extra <br /> Bed's</th>
                                    <th className='text-center' style={{ width: "138px" }}> Amount </th>
                                    <th style={{ width: "90px" }}>Tax %</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th style={{ width: "83px" }}> Action </th>
                                  </tr>
                                </thead>

                                {/* <tbody>
                                  {roomDetails.flatMap((room, roomIdx) =>
                                    Array.from({ length: room.TotalRoom || 1 }, (_, index) => (
                                      <tr key={`${roomIdx}-${index}`}>
                                        <td>{room.RoomName}</td>
                                        {Pms?.PMS === "Opera" && (<td>{room.RatePlan}</td>)}
                                        <td>{room.MealPlan}</td>
                                        <td className='text-center'>{room.Adults}</td>
                                        <td className='text-center'>{room.Child}</td>
                                        <td className='text-center'>{room.ExtraBed}</td>

                                        <td className="text-center d-flex">
                                          <input
                                            type="text"
                                            readOnly={editingRoomId !== room.RoomID}
                                            value={
                                              editingRoomId === room.RoomID
                                                ? tempAmount[room.RoomID] ?? room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                                : room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                            }
                                            onChange={(e) => handleAmountInputChange(room.RoomID, e.target.value)}
                                            className="form-control form-control-sm text-center me-2"
                                            style={{ width: "100px", margin: "auto" }}
                                          />

                                          {editingRoomId === room.RoomID ? (
                                            <div className="d-flex align-items-center gap-1">
                                              <button
                                                type="button"
                                                className="btn p-0 text-success"
                                                onClick={() => handleSaveClick(room.RoomID)}
                                                title="Save"
                                              >
                                                <i className="fas fa-check mx-3"></i>
                                              </button>
                                              <button
                                                type="button"
                                                className="btn p-0 text-danger"
                                                onClick={handleCancelClick}
                                                title="Cancel"
                                              >
                                                <i className="fas fa-times"></i>
                                              </button>
                                            </div>
                                          ) : (
                                            <button
                                              type="button"
                                              className="btn p-0 "
                                              onClick={() =>
                                                handleEditClick(
                                                  room.RoomID,
                                                  room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0))
                                                )
                                              }
                                              title="Edit"
                                            >
                                              <i className="fas fa-edit"></i>
                                            </button>
                                          )}

                                        </td>

                                        <td className='text-center'>
                                          <button type='button' className=' btn py-0 px-1' style={{ color: "red" }} onClick={() => handleDeleteRoom(room.ID, masterDetails?.PreBookingToken)}><i className='fas fa-trash'></i></button>
                                        </td>
                                      </tr>
                                    ))
                                  )}

                                </tbody> */}

                                {/* --- 2) tbody mapping: replace your existing tbody with this --- */}
                                <tbody>
                                  {roomDetails.flatMap((room, roomIdx) =>
                                    Array.from({ length: room.TotalRoom || 1 }, (_, index) => {
                                      const rowKey = `${roomIdx}-${index}`; // UNIQUE per rendered row (even if same RoomID)
                                      const defaultAmount = room.Amount ?? (room.TotalRoom * room.RoomRate + (room.ExtraBedAmount || 0));

                                      const displayedValue =
                                        editingRowKey === rowKey
                                          ? (tempAmount[rowKey] ?? defaultAmount)
                                          : (savedAmounts[rowKey] ?? defaultAmount);

                                      return (
                                        <tr key={rowKey}>
                                          <td>{room.RoomName}</td>
                                          {Pms?.PMS === "Opera" && <td>{room.RatePlan}</td>}
                                          <td>{room.MealPlan}</td>
                                          <td className="text-center">{room.Adults}</td>
                                          <td className="text-center">{room.Child}</td>
                                          <td className="text-center">{room.ExtraBed}</td>

                                          {/* <td className="text-center d-flex">
                                            <input
                                              type="text"
                                              readOnly={editingRowKey !== rowKey}
                                              value={displayedValue}
                                              onChange={(e) => handleAmountInputChange(rowKey, e.target.value)}
                                              className="form-control form-control-sm text-center me-2"
                                              style={{ width: "100px", margin: "auto" }}
                                            />

                                            {editingRowKey === rowKey ? (
                                              <div className="d-flex align-items-center gap-1">
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-success"
                                                  onClick={() => handleSaveClick(rowKey, room, index)}
                                                  title="Save"
                                                >
                                                  <i className="fas fa-check mx-3"></i>
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-danger"
                                                  onClick={handleCancelClick}
                                                  title="Cancel"
                                                >
                                                  <i className="fas fa-times"></i>
                                                </button>
                                              </div>
                                            ) : (
                                              <button
                                                type="button"
                                                className="btn p-0"
                                                onClick={() => handleEditClick(rowKey, savedAmounts[rowKey] ?? defaultAmount)}
                                                title="Edit"
                                              >
                                                <i className="fas fa-edit"></i>
                                              </button>
                                            )}
                                          </td> */}

                                          <td className="text-center">
                                            {/* <input
                                              type="text"
                                              readOnly={editingRowKey !== rowKey}
                                              value={displayedValue}
                                              onChange={(e) => handleAmountInputChange(rowKey, e.target.value)}
                                              className="form-control form-control-sm text-center"
                                              style={{ width: "100px" }}
                                            /> */}

                                            <input
                                              type="text"
                                              readOnly={editingRowKey !== rowKey}
                                              value={displayedValue}
                                              onChange={(e) => {
                                                const val = Number(e.target.value) || 0;

                                                handleAmountInputChange(rowKey, val);

                                                const selectedTax = rowTax[rowKey] ?? 0;
                                                calculateRowAmounts(rowKey, val, selectedTax);
                                              }}
                                              className="form-control text-center"
                                              style={{ width: "100px" }}
                                            />

                                          </td>

                                          <td>
                                            <select
                                              className="form-select"
                                              disabled={editingRowKey !== rowKey}
                                              value={rowTax[rowKey] ?? ""}
                                              onChange={(e) => {
                                                const taxVal = e.target.value;
                                                setRowTax(prev => ({ ...prev, [rowKey]: taxVal }));

                                                const amt =
                                                  editingRowKey === rowKey
                                                    ? tempAmount[rowKey] ?? defaultAmount
                                                    : displayedValue;

                                                calculateRowAmounts(rowKey, amt, taxVal);
                                              }}
                                            >
                                              <option value="">Select</option>
                                              <option value={5}>5%</option>
                                              <option value={18}>18%</option>
                                            </select>
                                          </td>

                                          <td className="text-center">
                                            {(rowTaxAmount[rowKey] ?? 0).toFixed(2)}
                                          </td>

                                          <td className="text-center">
                                            {(rowTotal[rowKey] ?? displayedValue).toFixed(2)}
                                          </td>

                                          <td className="text-center">
                                            {editingRowKey === rowKey ? (
                                              <>
                                                {/* SAVE */}
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-success me-3"
                                                  onClick={() => handleSaveClick(rowKey, room, index)}
                                                  title="Save"
                                                >
                                                  <i className="fas fa-check" style={{ fontSize: "16px" }}></i>
                                                </button>

                                                {/* CANCEL */}
                                                <button
                                                  type="button"
                                                  className="btn p-0 text-danger"
                                                  onClick={handleCancelClick}
                                                  title="Cancel"
                                                >
                                                  <i className="fas fa-times" style={{ fontSize: "16px" }}></i>
                                                </button>
                                              </>
                                            ) : (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  onClick={() =>
                                                    handleEditClick(rowKey, savedAmounts[rowKey] ?? defaultAmount)
                                                  }
                                                  title="Edit"
                                                >
                                                  <i className="fas fa-edit me-3"></i>
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  style={{ color: "red" }}
                                                  onClick={() =>
                                                    handleDeleteRoom(room.ID, masterDetails?.PreBookingToken)
                                                  }
                                                  title="Delete"
                                                >
                                                  <i className="fas fa-trash"></i>
                                                </button>
                                              </div>
                                            )}
                                          </td>

                                        </tr>
                                      );
                                    })
                                  )}
                                </tbody>


                              </table>
                            </div>
                          </div>


                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className="fw-bold position-absolute rounded-2"
                                style={{
                                  top: "-12px",
                                  paddingInline: "8px",
                                  backgroundColor: "#f5f7fd ",
                                  left: "5px",
                                }}
                              >
                                Total Amount{" "}
                              </h6>
                              <div className="row align-items-end p-3">
                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Amount
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={baseAmount.toFixed(2) || "0.00"}
                                      readOnly
                                    />

                                  </div>
                                </div>

                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">+</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <div className="d-flex gap-2 mb-1">
                                      <label className="col-form-label">
                                        Tax
                                      </label>
                                    </div>

                                    <input
                                      type="number"
                                      className="form-control"
                                      value={finalTaxAmount.toFixed(2)}
                                      readOnly
                                    />

                                  </div>

                                </div>


                                <div className="col-auto d-flex align-items-end pb-1">
                                  <span className="fw-bold fs-3">=</span>
                                </div>

                                <div className="col-auto">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Total Amount After Tax
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={finalTotalAfterTax.toFixed(2)}
                                      readOnly
                                    />

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          {/* guest details table */}

                          <div className="col-md-12">
                            <h4 className="mt-3">Guest Details:</h4>
                            <div className="table-responsive">
                              <table
                                className="display table table-striped table-bordered table-hover"
                                style={{
                                  width: "100%",
                                  tableLayout: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact No </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <select className='form-select form-control' value={formData.Title} onChange={(e) => setFormData({ ...formData, Title: e.target.value })}>
                                        <option>Select Prifix</option>
                                        <option>Mr.</option>
                                        <option>Mrs.</option>
                                        <option>Ms.</option>
                                        <option>Dr.</option>
                                      </select>
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter First Name" value={formData.FirstName} onChange={(e) => setFormData({ ...formData, FirstName: e.target.value })} />
                                    </td>
                                    <td>
                                      <input type="text" className="form-control" placeholder="Enter Last Name" value={formData.LastName} onChange={(e) => setFormData({ ...formData, LastName: e.target.value })} />
                                    </td>
                                    <td>
                                      <input type="number" className="form-control" placeholder="Enter Contact No" value={formData.MobileNumber} onChange={(e) => setFormData({ ...formData, MobileNumber: e.target.value })} />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="input-block ">
                              <label className="col-form-label">Email:</label>
                              {/* <input type="email" className="form-control" placeholder="Enter Email" value={formData.EmailAddress} onChange={(e) => setFormData({ ...formData, EmailAddress: e.target.value })} /> */}
                              <TagsInput
                                value={formData.EmailAddress}
                                onChange={(emails) => setFormData({ ...formData, EmailAddress: emails })}
                                name="emails"
                                placeHolder="Enter email "
                              />
                              <div className="form-check d-flex">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault"  >
                                  Do want to receive Booking Voucher on email ?
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input-block">
                              <label className="col-form-label">Address</label>
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter Address"
                                value={formData.Address}
                                onChange={(e) => setFormData({ ...formData, Address: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="input-block">
                              <label className="col-form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter City"
                                value={formData.City}
                                onChange={(e) => setFormData({ ...formData, City: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">Country</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Country"
                                value={formData.Country}
                                onChange={(e) => setFormData({ ...formData, Country: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">State</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter State"
                                value={formData.State}
                                onChange={(e) => setFormData({ ...formData, State: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="col-md-3 ">
                            <div className="input-block">
                              <label className="col-form-label">
                                Company Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Company Name"
                                value={formData.CompanyName}
                                onChange={(e) => setFormData({ ...formData, CompanyName: e.target.value })}
                              />
                            </div>
                          </div>

                          <div className="m-1 mt-4">
                            <div className="border bg-gray1 rounded-2 position-relative">
                              <h6
                                className=" fw-bold position-absolute bg-gray1 rounded-2"
                                style={{
                                  top: "-12px",
                                  left: "12px",
                                  paddingInline: "4px",
                                }}
                              >
                                Enter GST Details (Optional)
                              </h6>
                              <div className="row p-3">
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registration Number
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registration Number"
                                      value={formData.RegistrationNumber}
                                      onChange={(e) => setFormData({ ...formData, RegistrationNumber: e.target.value })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Registred Company Name"
                                      value={formData.RegistrationCompanyName}
                                      onChange={(e) => setFormData({ ...formData, RegistrationCompanyName: e.target.value })}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 ">
                                  <div className="input-block">
                                    <label className="col-form-label">
                                      Registered Company address
                                    </label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Registered Company Address"
                                      value={formData.RegistrationCompanyAddress}
                                      onChange={(e) => setFormData({ ...formData, RegistrationCompanyAddress: e.target.value })}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Billing Instructions:
                              </label>
                              <select className="form-select form-control" value={formData.BillingInstruction}
                                onChange={(e) =>
                                  setFormData({ ...formData, BillingInstruction: e.target.value })
                                }>
                                <option>Select Billing Instruction</option>
                                <option value="Pay at hotel">Pay at hotel</option>
                                <option value="Prepaid">Prepaid</option>
                                <option value="Send Invoice">Send Invoice</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label" htmlFor="marketSegment">
                                Market Segment
                              </label>
                              <select

                                className="form-select form-control"
                                value={formData.MarketSegment}
                                onChange={(e) =>
                                  setFormData({ ...formData, MarketSegment: e.target.value })
                                }
                              >
                                <option value="">Select</option>
                                {marketSegments &&
                                  marketSegments.map((item) => (
                                    <option key={item.ID} value={item.Code}>
                                      {item.MarketSeg}
                                    </option>
                                  ))}

                              </select>
                            </div>
                          </div>



                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Business Source</label>
                              <select
                                className="form-select form-control"
                                value={formData.BusinessSource}
                                onChange={(e) =>
                                  setFormData({ ...formData, BusinessSource: e.target.value })
                                }
                              >
                                <option value="">Select</option>

                                {businessSources.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.BusinessSource}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>


                          <div className="col-md-3">
                            <div className="input-block mb-3">
                              <label className="col-form-label">
                                Guarantee Codes
                              </label>
                              <select
                                className="form-select form-control"
                                value={formData.GuaranteeCodes}
                                onChange={(e) =>
                                  setFormData({ ...formData, GuaranteeCodes: e.target.value })
                                }
                              >
                                <option value="">Select</option>
                                {guaranteeCodes.map((item) => (
                                  <option key={item.ID} value={item.Code}>
                                    {item.guaranteeCodes}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Booking Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Special Requriment"
                                value={formData.BookingComment}
                                onChange={(e) => setFormData({ ...formData, BookingComment: e.target.value })}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="ïnput-block mb-3">
                              <label className="col-from-lable">
                                Payment Comment
                              </label>
                              <textarea
                                className="form-control"
                                placeholder="Payment Comment"
                                value={formData.PaymentComment}
                                onChange={(e) => setFormData({ ...formData, PaymentComment: e.target.value })}
                              ></textarea>
                            </div>
                          </div>

                          {/* <!-- Submit Button --> */}
                          <div className="card-action text-end">
                            <button type="submit" className="btn btn-black">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <>
          <div
            id="con-close-modal"
            className="modal fade"
            tabIndex={-1}
            role="dialog"
            aria-hidden="true"
            style={{ display: "none" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Add Room</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body p-4">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label"> ROOM TYPE </label>
                        <select className="form-control form-select" value={selectedRoom?.RoomID || ""} onChange={handleRoomChange}>
                          <option>select type</option>
                          {rooms.map((room) => (
                            <option key={room.RoomID} value={room.RoomID}>
                              {room.RoomName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {Pms?.PMS === "Opera" && (<div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label"> Rate Code </label>
                        <select className="form-select form-control" value={selectedRateCode}
                          onChange={(e) => setSelectedRateCode(e.target.value)}>
                          <option>Select Code</option>

                          {ratecode.map((item) => (
                            <option key={item.RateCodeID} value={item.Code}>
                              {item.Name}
                            </option>
                          ))}
                        </select>

                      </div>
                    </div>)}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label"> MEAL PLAN </label>
                        <select className="form-control form-select" value={selectedMealPlan}
                          onChange={(e) => setSelectedMealPlan(e.target.value)}>
                          <option>Select Plan</option>

                          {mealplan.map((item) => (
                            <option key={item.MealPlanID} value={item.Code}>
                              {item.Name}
                            </option>
                          ))}
                        </select>

                      </div>
                    </div>
                    <div className='col-md-12'>
                      <div className='mb-3'>
                        <label className='form-label'>Add Room Amount</label>
                        <input className='form-control' type='number' min={0} value={roomAmount}
                          onChange={(e) => setRoomAmount(e.target.value)} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> ADULT </label>
                        <select className="form-control form-select" value={adults}
                          onChange={(e) => setAdults(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> CHILD </label>
                        <select className="form-control form-select" value={children}
                          onChange={(e) => setChildren(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label"> EXTRA BED </label>
                        <select className="form-control form-select" value={extraBed}
                          onChange={(e) => setExtraBed(e.target.value)}>
                          <option>0</option>
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info waves-effect waves-light" onClick={handleAddRoomSave} >
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /.modal */}
        </>

      </div>
    </>

  );
};


export default HotelBooking;